import moment from 'moment';
import { DATE_DIMENSION } from '@/pages/dashboard/pages/overview/_config/constant';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';

export function momentFormat(date, format = 'YYYY-MM-DD') {
  if (typeof date !== 'string') {
    date = moment(date).toString();
  }
  return dateTimeFormat(date, format) || '';
}

export function getCurrWeekfirstDay(date) {
  return momentFormat(moment(date).startOf('isoWeek'));
}

export function getSubTitleDate({ timeType, filterValue }) {
  const { rangeTime } = filterValue ?? {};
  switch (timeType) {
    case 'Week':
      return `${getCurrWeekfirstDay(rangeTime?.[1])}~${rangeTime?.[1]}`;
    case 'Month':
      return momentFormat(rangeTime?.[1], 'YYYY-MM');
    default:
      return rangeTime?.[1];
  }
}

export const timeRange: any = {
  Day: [moment().subtract(1, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
  Week: [
    moment().week(moment().week() - 1).startOf('isoWeek').format('YYYY-MM-DD'),
    moment().week(moment().week() - 1).endOf('isoWeek').format('YYYY-MM-DD')
  ],
  Month: [
    moment().month(moment().month() - 1).startOf('month').format('YYYY-MM-DD'),
    moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD')
  ],
};

export const getRangTime = (rangTime, filterObj) => {
  const { rangeTime = [], timeType = '' } = filterObj;
  let startTime = rangeTime?.[0];
  const endTime = moment(rangeTime?.[1]);
  /**
   * day 少于七天补足七天
   * week 少于六周补足六周  推到星期一
   * month 少于六月补足六月
  */
  switch (timeType) {
    case DATE_DIMENSION.DAY: {
      const diffTime = moment(endTime).diff(moment(rangeTime?.[0]), 'day');
      if (diffTime < 7) {
        startTime = moment(rangeTime?.[1]).subtract(6, 'day').format('YYYY-MM-DD');
      }
      break;
    }
    case DATE_DIMENSION.WEEK: {
      const diffTime = moment(endTime).diff(moment(rangeTime?.[0]), 'week');
      if (diffTime < 6) {
        startTime = moment(rangeTime?.[1]).subtract(6, 'week').add(1, 'day').format('YYYY-MM-DD');
      }
      break;
    }
    case DATE_DIMENSION.MONTH: {
      const diffTime = moment(endTime).diff(moment(rangeTime?.[0]), 'month');
      if (diffTime < 6) {
        startTime = moment(rangeTime?.[1]).subtract(5, 'month').startOf('M').format('YYYY-MM-DD');
      }
      break;
    }
  }
  return [startTime, rangTime?.[1]];
};

